import React from "react";
import { Select } from "basis";

import { COUNTRY } from "../../core/constants";

const countryOptions = [
  {
    label: "Australia",
    value: COUNTRY.AU,
  },
  {
    label: "New Zealand",
    value: COUNTRY.NZ,
  },
];

const CountryDropdown = ({ name = "country" }) => (
  <Select color="white" name={name} label="Country" options={countryOptions} />
);

export default CountryDropdown;
